import React, { Fragment } from 'react'
import { translate } from '../Services/translation'

const TopLinks = ({
    links,
    iconCssClass,
    menuLinkTitle,
    showOnlyTextIfSingleLink,
    showTopLinks,
    toggleShowTopLinks,
}) => {
    return (
        <Fragment>
            {links && links.length > 0 && (
                <Fragment>
                    {links.length > 1 ? (
                        <Fragment>
                            <a
                                className="top-link__link--block"
                                href="#!"
                                onClick={() => toggleShowTopLinks()}
                                title={translate(menuLinkTitle)}
                            >
                                <i
                                    className={'top-link__icon ' + iconCssClass}
                                ></i>
                                <span className="top-link__title--hidden">
                                    {translate('toplinks.title')}
                                </span>
                            </a>
                            <div
                                className={`top-link__links ${
                                    !showTopLinks
                                        ? 'top-link__links--hidden'
                                        : ''
                                }`}
                            >
                                {links.map((link, index) => (
                                    <div key={index} className="top-link__item">
                                        <a
                                            className="top-link__link"
                                            href={link.href}
                                        >
                                            <span className="top-link__item-title">
                                                {link.text}
                                            </span>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </Fragment>
                    ) : showOnlyTextIfSingleLink ? (
                        <a
                            className="top-link__link--block"
                            href={links[0].href}
                        >
                            <span className="top-link__title">
                                {links[0].text}
                            </span>
                        </a>
                    ) : (
                        <a
                            className="top-link__link--block"
                            href={links[0].href}
                            title={links[0].text}
                        >
                            <i className={'top-link__icon ' + iconCssClass}></i>
                            <span className="top-link__title--hidden">
                                {links[0].text}
                            </span>
                        </a>
                    )}
                </Fragment>
            )}
        </Fragment>
    )
}

export default TopLinks
